module.exports = __webpack_public_path__ + "static/media/bettyblocks.1aa0dfe5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bettyblocks.webp
// module id = 443
// module chunks = 0